import React from 'react'
import BaseProggressBar from '../../sisu/overlay/BaseProgressBar.sisu'

const NeoProgressBar = (props) => {
  return <BaseProggressBar {...props} />
}

export default NeoProgressBar